import { Spin } from "antd";

import * as theme from "./PageSpinner.css";

export const PageSpinner = () => {
    return (
        <div className={theme.spinWrapper}>
            <Spin size="large" />
        </div>
    );
};
